export default {
	code: [
		{
			code: '04',
			name: 'RUC',
			typePerson: 7,
		},
		{
			code: '05',
			name: 'CEDULA',
			typePerson: 8,
		},
		{
			code: '06',
			name: 'PASAPORTE',
			typePerson: 9,
		},
		{
			code: '07',
			name: 'CONSUMIDOR',
			typePerson: 10,
		},
	],
};



// WEBPACK FOOTER //
// ./src/shared/codeSales.js